// extracted by mini-css-extract-plugin
module.exports = {"btn":"Loader_btn__a85dw"};